import ApiService from "./ApiService"
import {
  ListDynamicChannelsRequest,
  GetChannelTypesRequest,
  GetChannelInstancesRequest,
  PostCreateDynamicChannelsRequest,
} from "../api/requestObjects"

class DynamicChannelsApiService extends ApiService {

  /**
   * Fetch list of dynamic channels
   * 
   * @param {JSON} params
   * @return {Promise}
   */
  getDynamicChannels = (params) => {

    const { GET_DYNAMIC_CHANNELS } = this.endpoints
    const payload = new ListDynamicChannelsRequest(params)

    return this.API(this.getEndpoint({
      path: GET_DYNAMIC_CHANNELS,
      params: payload.getPayload()
    }))
  }

  /**
   * Fetch channel types based on entity type
   * 
   * @param {JSON} params
   * @return {Promise}
   */
  getChannelTypes = (params) => {

    const { GET_CHANNEL_TYPES } = this.endpoints
    const payload = new GetChannelTypesRequest(params)

    return this.API(this.getEndpoint({
      path: GET_CHANNEL_TYPES,
      params: payload.getPayload()
    }))
  }

  /**
   * Fetch channel instances for a specific channel type
   * 
   * @param {JSON} params
   * @return {Promise}
   */
  getChannelInstances = (params) => {

    const { GET_CHANNEL_INSTANCES } = this.endpoints
    const payload = new GetChannelInstancesRequest(params)

    return this.API(this.getEndpoint({
      path: GET_CHANNEL_INSTANCES,
      params: payload.getPayload()
    }))
  }

  /**
   * Create dynamic channels
   * 
   * @param {JSON} params
   * @return {Promise}
   */
  postCreateDynamicChannels = (params) => {

    const { POST_CREATE_DYNAMIC_CHANNELS } = this.endpoints
    const payload = new PostCreateDynamicChannelsRequest(params)

    return this.API.post(this.getEndpoint({
      path: POST_CREATE_DYNAMIC_CHANNELS,
    }), payload.getPayload())
  }
}

export default DynamicChannelsApiService
